<template>
    <div class="icon-Overflow-Menu-Vertical"></div>
</template>